/* eslint-disable */

import * as ApolloReactComponents from '@apollo/client/react/components';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetOrCreateBriefForOrderItemMutationVariables = Types.Exact<{
    id: Types.Scalars['String'];
}>;

export type GetOrCreateBriefForOrderItemMutation = {
    __typename: 'Mutation';
    orderItem: { __typename: 'OrderItem'; externalBriefId: string };
};

export const GetOrCreateBriefForOrderItemDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'getOrCreateBriefForOrderItem' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'orderItem' },
                        name: { kind: 'Name', value: 'getOrCreateBriefForOrderItem' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'externalBriefId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type GetOrCreateBriefForOrderItemMutationFn = Apollo.MutationFunction<
    GetOrCreateBriefForOrderItemMutation,
    GetOrCreateBriefForOrderItemMutationVariables
>;
export type GetOrCreateBriefForOrderItemComponentProps = Omit<
    ApolloReactComponents.MutationComponentOptions<
        GetOrCreateBriefForOrderItemMutation,
        GetOrCreateBriefForOrderItemMutationVariables
    >,
    'mutation'
>;

export const GetOrCreateBriefForOrderItemComponent = (
    props: GetOrCreateBriefForOrderItemComponentProps
) => (
    <ApolloReactComponents.Mutation<
        GetOrCreateBriefForOrderItemMutation,
        GetOrCreateBriefForOrderItemMutationVariables
    >
        mutation={GetOrCreateBriefForOrderItemDocument}
        {...props}
    />
);

/**
 * __useGetOrCreateBriefForOrderItemMutation__
 *
 * To run a mutation, you first call `useGetOrCreateBriefForOrderItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateBriefForOrderItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateBriefForOrderItemMutation, { data, loading, error }] = useGetOrCreateBriefForOrderItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrCreateBriefForOrderItemMutation(
    baseOptions?: Apollo.MutationHookOptions<
        GetOrCreateBriefForOrderItemMutation,
        GetOrCreateBriefForOrderItemMutationVariables
    >
) {
    return Apollo.useMutation<
        GetOrCreateBriefForOrderItemMutation,
        GetOrCreateBriefForOrderItemMutationVariables
    >(GetOrCreateBriefForOrderItemDocument, baseOptions);
}
export type GetOrCreateBriefForOrderItemMutationHookResult = ReturnType<
    typeof useGetOrCreateBriefForOrderItemMutation
>;
export type GetOrCreateBriefForOrderItemMutationResult =
    Apollo.MutationResult<GetOrCreateBriefForOrderItemMutation>;
export type GetOrCreateBriefForOrderItemMutationOptions = Apollo.BaseMutationOptions<
    GetOrCreateBriefForOrderItemMutation,
    GetOrCreateBriefForOrderItemMutationVariables
>;
